import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { INavigationTileItem } from '@verzekeringapp-mono/shared/src/models/navigation_tile_item'
import React from 'react'

interface IProps {
  data: INavigationTileItem
  onPress?: () => void
}

const ProfileNavigationButton: React.FC<IProps> = props => {
  const { onPress } = props
  const baseClassName = 'mb-4 flex h-[60px] w-full items-center gap-4 rounded-md border border-border-subtle bg-surface-card px-4 text-left text-text-primary'
  const content = (
    <>
      {props.data.icon !== 'nh' && (
        <div className='flex h-[34px] w-[34px] items-center justify-center rounded-full bg-surface-brand-subtle text-icon-brand'>
          <FontAwesomeIcon
            icon={props.data.icon}
            className='text-icon-brand'
          />
        </div>
      )}

      <p className='text-base text-text-primary'>{props.data.title}</p>
    </>
  )

  return (
    <>
      {onPress
        ? (
          <button
            type='button'
            className={baseClassName}
            onClick={onPress}
          >
            {content}
          </button>
        )
        : (
          <a
            className={baseClassName}
            href={props.data.href}
          >
            {content}
          </a>
        )}
    </>
  )
}

export default ProfileNavigationButton
